import React, { Component } from "react";
import _ from "lodash";
import { Table } from "semantic-ui-react";
import getPersonName from "../common/Name";
import { getDate, getDobDate } from "../common/DisplayDate";
import Address from "./Address";
import getSsn from "../common/Ssn";

class VoterRegistrationRecordDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const { node } = this.props;
    if (node !== undefined && node !== null) {
      const nameNode = _.get(node, "name[0]");
      results.push(
        <Table.Row key={`VoterReg_Record_Name_Row_${this.props.index}`}>
          <Table.Cell width={3}>Name:</Table.Cell>
          <Table.Cell width={5}>
            {nameNode &&
              getPersonName(
                _.get(nameNode, "first[0]._", ""),
                "",
                _.get(nameNode, "last[0]._", ""),
                this.props
              )}
          </Table.Cell>
          <Table.Cell width={3}>Political Party:</Table.Cell>
          <Table.Cell width={5}>
            {_.get(node, "politicalParty[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      const residentAddress = _.get(node, "residentAddress[0]");
      results.push(
        <Table.Row key={`VoterReg_Record_Address_Row_${this.props.index}`}>
          <Table.Cell width={3}>Address:</Table.Cell>
          <Table.Cell width={5}>
            {residentAddress && (
              <Address addressNode={residentAddress} {...this.props} />
            )}
          </Table.Cell>
          <Table.Cell width={3}>Status:</Table.Cell>
          <Table.Cell width={5}>
            {_.get(node, "activeOrInactive[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      results.push(
        <Table.Row key={`VoterReg_Record_Dob_Row_${this.props.index}`}>
          <Table.Cell width={3}>Date of Birth:</Table.Cell>
          <Table.Cell width={5}>
            {getDobDate(_.get(node, "DOB[0]"), {
              userAccount: this.props.userAccount,
            })}
          </Table.Cell>
          <Table.Cell width={3}>Registrate State:</Table.Cell>
          <Table.Cell width={5}>
            {_.get(node, "registrateStateName[0]._", "")}
          </Table.Cell>
        </Table.Row>
      );
      const ssn = _.get(node, "SSN[0]._");
      const regDate = _.get(node, "registrationDate[0]");
      results.push(
        <Table.Row key={`VoterReg_Record_Ssn_Row_${this.props.index}`}>
          <Table.Cell width={3}>SSN:</Table.Cell>
          <Table.Cell width={5}>{ssn && getSsn(ssn, this.props)}</Table.Cell>
          <Table.Cell width={3}>Registration Date:</Table.Cell>
          <Table.Cell width={5}>{regDate && getDate(regDate)}</Table.Cell>
        </Table.Row>
      );

      const lastVoteDate = _.get(node, "lastVoteDate[0]");
      results.push(
        <Table.Row key={`VoterReg_Record_Gender_Row_${this.props.index}`}>
          <Table.Cell width={3}>Gender:</Table.Cell>
          <Table.Cell width={5}>{_.get(node, "gender[0]._", "")}</Table.Cell>
          <Table.Cell width={3}>Last Vote Date:</Table.Cell>
          <Table.Cell width={5}>
            {lastVoteDate && getDate(lastVoteDate)}
          </Table.Cell>
        </Table.Row>
      );
    }
    return (
      <Table>
        <Table.Body>{results}</Table.Body>
      </Table>
    );
  }
}

export default VoterRegistrationRecordDetail;



// WEBPACK FOOTER //
// ./src/components/searchresults/VoterRegistrationRecordDetail.js